import constant from '../constants/movieConstant';

export const movieInitialState = {
    searchResult: {
        data: null,
        error: null,
        isLoading: false
    },
    addResult: {
        data: null,
        error: null,
        isLoading: false
    },
    shouldResult: {
        data: null,
        error: null,
        isLoading: false
    },
    getResult: {
        data: null,
        error: null,
        isLoading: false
    },
    searchAuthorResult: {
        data: null,
        error: null,
        isLoading: false
    },
    paginateResult: {
        data: null,
        error: null,
        isLoading: false
    },
    addListResult: {
        data: null,
        error: null,
        isLoading: false
    }
}

export function movieReducer(state, action) {

    switch (action.type) {

        case constant.ADD_REQUEST:
            return {
                ...state,
                addResult: {
                    data: null,
                    error: null,
                    isLoading: true
                }
            };

        case constant.ADD_SUCCESS:
            return {
                ...state,
                addResult: {
                    data: action.payload,
                    error: null,
                    isLoading: false
                }
            };

        case constant.ADD_FAIL:
            return {
                ...state,
                addResult: {
                    data: null,
                    error: action.payload,
                    isLoading: false
                }
            };

        case constant.GET_REQUEST:
            return {
                ...state,
                getResult: {
                    data: null,
                    error: null,
                    isLoading: true
                }
            };

        case constant.GET_SUCCESS:
            return {
                ...state,
                getResult: {
                    data: action.payload,
                    error: null,
                    isLoading: false
                }
            };

        case constant.GET_FAIL:
            return {
                ...state,
                getResult: {
                    data: null,
                    error: action.payload,
                    isLoading: false
                }
            };

        case constant.SEARCH_AUTHOR_REQUEST:
            return {
                ...state,
                searchAuthorResult: {
                    data: null,
                    error: null,
                    isLoading: true
                }
            };

        case constant.SEARCH_AUTHOR_SUCCESS:
            return {
                ...state,
                searchAuthorResult: {
                    data: action.payload,
                    error: null,
                    isLoading: false
                }
            };

        case constant.SEARCH_AUTHOR_FAIL:
            return {
                ...state,
                searchAuthorResult: {
                    data: null,
                    error: action.payload,
                    isLoading: false
                }
            };

        case constant.SEARCH_REQUEST:
            return {
                ...state,
                searchResult: {
                    data: null,
                    error: null,
                    isLoading: true
                }
            };

        case constant.SEARCH_SUCCESS:
            return {
                ...state,
                searchResult: {
                    data: action.payload,
                    error: null,
                    isLoading: false
                }
            };

        case constant.SEARCH_FAIL:
            return {
                ...state,
                searchResult: {
                    data: null,
                    error: action.payload,
                    isLoading: false
                }
            };

        case constant.PAGINATE_REQUEST:
            return {
                ...state,
                paginateResult: {
                    data: null,
                    error: null,
                    isLoading: true
                }
            };

        case constant.PAGINATE_SUCCESS:
            return {
                ...state,
                paginateResult: {
                    data: action.payload,
                    error: null,
                    isLoading: false
                },
                movieDetailId: movieInitialState.movieDetailId
            };

        case constant.PAGINATE_FAIL:
            return {
                ...state,
                paginateResult: {
                    data: null,
                    error: action.payload,
                    isLoading: false
                }
            };

        case constant.SHOULD_REQUEST:
            return {
                ...state,
                shouldResult: {
                    data: null,
                    error: null,
                    isLoading: true
                }
            };

        case constant.SHOULD_SUCCESS:
            return {
                ...state,
                shouldResult: {
                    data: action.payload,
                    error: null,
                    isLoading: false
                }
            };

        case constant.SHOULD_FAIL:
            return {
                ...state,
                shouldResult: {
                    data: null,
                    error: action.payload,
                    isLoading: false
                }
            };

        case constant.ADD_LIST_REQUEST:
            return {
                ...state,
                addListResult: {
                    data: null,
                    error: null,
                    isLoading: true
                }
            };

        case constant.ADD_LIST_SUCCESS:
            return {
                ...state,
                addListResult: {
                    data: action.payload,
                    error: null,
                    isLoading: false
                }
            };

        case constant.ADD_LIST_FAIL:
            return {
                ...state,
                addListResult: {
                    data: null,
                    error: action.payload,
                    isLoading: false
                }
            };

        case constant.RESET:
            return {
                ...state,
                addResult: movieInitialState.addResult,
                movieDetailId: movieInitialState.movieDetailId,
                getResult: movieInitialState.getResult,
                paginateResult: movieInitialState.paginateResult,
                searchAuthorResult: movieInitialState.searchAuthorResult,
                searchResult: movieInitialState.searchResult,
                shouldResult: movieInitialState.shouldResult
            };

        default:
            return state;
    }
}

export default movieReducer;
